export default __webpack_public_path__ + "static/media/home-shop-modern-01.e8c4516a.jpg";